import { MATCH_DOLLAR_SIGN_WORD } from '../constants';

/**
 * TODO: refactor
 * Find every number with more then 3 digits
 * and insert a "." for formating.
 * @param {string} content - string which contains formatable words
 * @returns {string} - formatted string
 */
export const formatBandwidth = (content: string) => {
    if (content.length > 3) {
        const insertPosition = content.length - 3;

        return `${content.slice(0, insertPosition)}.${content.slice(
            insertPosition
        )}`;
    }

    return content;
};

/**
 * Find every word prefixed by '$' in the source
 * and replace each in the exact order of the other provided parameters.
 * @param {string} source - string which contains replaceable words
 * @param {string[]} contentList - strings to replace in the source
 * @returns {string} - formatted string
 */
export const formatText = (source: string = '', ...contentList: string[]) => {
    let result = source;

    for (const content of contentList) {
        result = result.replace(MATCH_DOLLAR_SIGN_WORD, content);
    }

    return result;
};

/**
 * Concatenates strings, where any of them might be undefined.
 *
 * @param {...(string | undefined)[]} strings - The strings to concatenate.
 * @returns {string} The concatenated result of all input strings , it return empty string if all passed strings are undefined.
 */
export const concatenateStrings = (
    ...strings: (string | undefined)[]
): string => {
    return strings.map((str) => str ?? '').join('');
};
